import { ServiceType } from 'src/app/core/common/types';

export function generateUrlByServiceType(type: ServiceType, slug: string) {
  switch (type) {
    case 'course':
      return 'edu-detail/' + slug;
    case 'article':
      return 'news-detail/' + slug;
    case 'custom_contract':
      return 'custom-contract/contract-detail/' + slug;
    case 'ready_contract':
      return 'ready-contract/contract-detail/' + slug;
    case 'smart_contract':
      return 'smart-contract/contract-detail/' + slug;
    case 'petition':
      return 'smart-petition/petition-detail/' + slug;
    case 'ready_petition':
      return 'ready-petition/petition-detail/' + slug;
    case 'custom_petition':
      return 'custom-petition/petition-detail/' + slug;
    case 'custom_complaint':
      return 'custom-complaint/complaint-detail/' + slug;
    case 'ready_complaint':
      return 'ready-complaint/complaint-detail/' + slug;
  }
}
